module.exports = __webpack_public_path__ + "img/lnd.0e8ae0b8.jpg";